import { Stack } from "@mui/material";

import FineGrainedChart from "../Charts/FineGrainedChart";
import LineChart from "../Charts/LineChart";
import DualFineGrainedChart from "../Charts/DualFineGrainedChart";
import AlertTable from "../Alerts/AlertTable";
import DualLineChart from "../Charts/DualLineChart";

const Cards = ({
  riskAssessmentData,
  fineGrainedHeartRateData,
  wellnessData,
  patientWellnessData,
  fineGrainedHRVData,
  sleepScoreData,
  sleepDurationData,
  activityData,
  walkData,
  calorieData,
  fineGrainedStressData,
  fineGrainedBloodPressureData,
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 mx-auto">
      {/* Row 1 */}
      <div className="card col-span-1 lg:col-span-2">
        <h3>System Alerts</h3>
        <AlertTable riskAssessmentData={riskAssessmentData} />
      </div>
      {/* Row 2 */}
      <div className="card">
        <Stack spacing={5}>
          <div>
            <h3>Heart Rate Average</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <LineChart
                chartData={patientWellnessData.heartRateList}
                xlabel={"Day"}
                yLabel={"Heart Rate"}
                y_low={40}
                y_high={120}
              />
            </div>
          </div>
          <div>
            <h3>Heart Rate Last 50 Data Points</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <FineGrainedChart
                chartData={fineGrainedHeartRateData}
                xlabel={"Timestamp"}
                yLabel={"Heart Rate"}
              />
            </div>
          </div>
        </Stack>
      </div>
      <div className="card">
        <Stack spacing={5}>
          <div>
            <h3>HRV Average</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <LineChart
                chartData={patientWellnessData.hrvList}
                xlabel={"Day"}
                yLabel={"HRV"}
                y_low={20}
                y_high={70}
              />
            </div>
          </div>
          <div>
            <h3>HRV Last 50 Data Points</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <FineGrainedChart
                chartData={fineGrainedHRVData}
                xlabel={"Timestamp"}
                yLabel={"HRV"}
              />
            </div>
          </div>
        </Stack>
      </div>
      {/* Row 3 */}
      <div className="card">
        <Stack spacing={5}>
          <div>
            <h3>Sleep Duration Average</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <LineChart
                chartData={patientWellnessData.sleepDurationList}
                xlabel={"Day"}
                yLabel={"Sleep Duration"}
                y_low={0}
                y_high={10}
              />
            </div>
          </div>
          <div>
            <h3>Sleep Duration Last 18 Data Points</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <FineGrainedChart
                chartData={sleepDurationData}
                xlabel={"Date"}
                yLabel={"Sleep Duration"}
              />
            </div>
          </div>
        </Stack>
      </div>
      <div className="card">
        <Stack spacing={5}>
          <div>
            <h3>Sleep Score Average</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <LineChart
                chartData={patientWellnessData.sleepScoreList}
                xlabel={"Day"}
                yLabel={"Sleep Score"}
                y_low={0}
                y_high={10}
              />
            </div>
          </div>
          <div>
            <h3>Sleep Score Last 18 Data Points</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <FineGrainedChart
                chartData={sleepScoreData}
                xlabel={"Date"}
                yLabel={"Sleep Score"}
              />
            </div>
          </div>
        </Stack>
      </div>
      {/* Row 4 */}
      <div className="card">
        <Stack spacing={5}>
          <div>
            <h3>Distance Averages</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <LineChart
                chartData={patientWellnessData.distanceList}
                xlabel={"Day"}
                yLabel={"Distance"}
                y_low={0}
                y_high={10}
              />
            </div>
          </div>
          <div>
            <h3>Distance Last 30 Data Points</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <FineGrainedChart
                chartData={walkData}
                xlabel={"Timestamp"}
                yLabel={"Distance"}
              />
            </div>
          </div>
        </Stack>
      </div>
      <div className="card">
        <Stack spacing={5}>
          <div>
            <h3>Calorie Averages</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <LineChart
                chartData={patientWellnessData.calorieList}
                xlabel={"Day"}
                yLabel={"Calories"}
                y_low={0}
                y_high={10}
              />
            </div>
          </div>
          <div>
            <h3>Calories Last 30 Data Points</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <FineGrainedChart
                chartData={calorieData}
                xlabel={"Timestamp"}
                yLabel={"Calories"}
              />
            </div>
          </div>
        </Stack>
      </div>
      {/* Row 5 */}
      <div className="card">
        <Stack spacing={5}>
          <div>
            <h3>Stress Averages</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <LineChart
                chartData={patientWellnessData.stressList}
                xlabel={"Day"}
                yLabel={"Stress"}
                y_low={10}
                y_high={60}
              />
            </div>
          </div>
          <div>
            <h3>Stress Last 50 Data Points</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <FineGrainedChart
                chartData={fineGrainedStressData}
                xlabel={"Timestamp"}
                yLabel={"Stress"}
              />
            </div>
          </div>
        </Stack>
      </div>
      <div className="card">
        <Stack spacing={5}>
          <div>
            <h3>Blood Pressure Average</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <DualLineChart
                chartData={patientWellnessData.bloodPressureList}
                xlabel={"Day"}
                yLabel1={"Systolic"}
                yLabel2={"Diastolic"}
                y_low={60}
                y_high={160}
              />
            </div>
          </div>
          <div>
            <h3>Blood Pressure Last 50 Data Points</h3>
            <div style={{ width: "100%", height: "250px" }}>
              <DualFineGrainedChart
                chartData={fineGrainedBloodPressureData}
                xlabel={"Timestamp"}
                yLabel1={"Systolic"}
                yLabel2={"Diastolic"}
              />
            </div>
          </div>
        </Stack>
      </div>
    </div>
  );
};

export default Cards;
